
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Administration</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">
            <table class="form-group form-group-sm" *ngIf="personnages">
              
              <thead style="position: sticky;top: 0; height:150px; background-color:grey">
                <tr class="border-bottom">
                  <th>Joueur</th><th>Email</th><th>Personnage</th><th>Crimson</th><th>But long terme</th>
                  <th>ButCourtTerme</th><th>Concept</th><th>Historique</th><th>Personnalité</th>
                  <th>Compétences</th><th>Talent</th>
                </tr>
              </thead>
              <tr *ngFor="let personnage of personnages" class="border-bottom">
                <td class="border">{{personnage.joueurNomComplet}}</td>
                <td class="border">{{personnage.joueurEmail}}</td>
                <td class="border">{{personnage.personnage.nom }}</td>
                <td class="border">{{personnage.personnage.crimsonDisponible }}</td>
                <td class="border">{{personnage.personnage?.background?.butLongTerme}}</td>
                <td class="border">{{personnage.personnage?.background?.butCourtTerme}}</td>
                <td class="border">{{personnage.personnage?.background?.concept}}</td>
                <td class="border">{{personnage.personnage?.background?.historique}}</td>
                <td class="border">{{personnage.personnage?.background?.personnalite}}</td>
                <td class="border">
                  <ul class="list-group" *ngFor="let competencePersonnage of getCompetencesPersonnage(personnage.personnage)">
                    <span>
                      {{competencePersonnage.description?.nom}}
                      <i class="list-group-item" *ngFor="let item of [].constructor(competencePersonnage.competence.niveau)" class="fas fa-solid fa-star">★</i>
                    </span>
                  </ul>
                </td>
                <td class="border">
                  <div class="list-group" *ngFor="let sortType of getSortsPersonnage(personnage.personnage)">
                    <b>{{sortType.name}}</b>
                    <ul class="list-group" *ngFor="let sort of sortType.sorts">
                      {{sort.description?.nom}}
                    </ul>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>